var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.95,
    height: 22.723,
    viewBox: "0 0 33.95 22.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2492",
    "data-name": "Group 2492",
    transform: "translate(-1250.25 -191.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-people",
    "data-name": "Icon material-people",
    d: "M24.648,17.238a4.735,4.735,0,0,0,4.614-4.869,4.628,4.628,0,1,0-9.244,0A4.748,4.748,0,0,0,24.648,17.238Zm-12.346,0a4.735,4.735,0,0,0,4.614-4.869A4.735,4.735,0,0,0,12.3,7.5a4.748,4.748,0,0,0-4.63,4.869A4.748,4.748,0,0,0,12.3,17.238Zm0,3.246c-3.6,0-10.8,1.9-10.8,5.681v4.058H23.1V26.165C23.1,22.383,15.9,20.484,12.3,20.484Zm12.346,0c-.448,0-.957.032-1.5.081a6.929,6.929,0,0,1,3.04,5.6v4.058H35.45V26.165C35.45,22.383,28.243,20.484,24.648,20.484Z",
    transform: "translate(1248.75 183.648)",
    fill: "#e00000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedTotal);
export default __webpack_public_path__ + "static/media/checked-total.307951f3d712a1c137981a6002d0196b.svg";
export { ForwardRef as ReactComponent };